/* eslint-disable no-unused-vars */
import "./AboutPage.css";
import images from '../../Asset/Img/img';
import ModalApp from "../../Components/Modal/Modal";
import { useTranslation } from 'react-i18next';

function AboutPage() {

  const { t } = useTranslation();

  return (
    <div className='about-container' >

      <div className='about-content'>
        {/* header section start */}
        <div className='about-header'>

          <div className='about-header-text'>
            <h4>{t('about-lid-header-text')}</h4>
          </div>

        </div>
        {/* header section end */}

        {/* Promotion section start */}

        <div className='promotion-container'>
          <div className='promotion-header'>
            <h3>{t('about-header')}</h3>
            <button>{t('about-video-button')}<img src={images.detailBtnIcon} alt="detail-icon" /></button>
          </div>

          <p>{t('about-promotion-p-one')}</p>

          <p>{t('about-promotion-p-two')}</p>

          <p>{t('about-promotion-p-three')} </p>

          <p>{t('about-promotion-p-four')} </p>

          <p>{t('about-promotion-p-five')}</p>

        </div>

        {/* Promotion section end */}

        {/* history section start */}

        <div className='history-container'>

          <div className='schema-content'>
            <img src={images.historyImg} alt="schema-img" />
          </div>

          <div className='schema-content-media'>
            <img src={images.historyMobile} alt="schema-img-mobile" />
          </div>
        </div>

        {/* history section end */}

        {/* vision-and-mission section start*/}

        <div className='vision-and-mission-container'>

          <div className='vision'>
            <h2>{t('about-vision-header')}</h2>
            <p>{t('about-vision-p-one')} </p>
            <p>{t('about-vision-p-two')} </p>
          </div>

          <div className='mission'>
            <h2>{t('about-mission-header')} </h2>
            <p>{t('about-mission-p-one')}</p>
            <p>{t('about-mission-p-two')}</p>
            <p>{t('about-mission-p-three')}</p>
          </div>
        </div>
        {/* vision-and-mission section end*/}
        {/* Gallery section start */}

        {/* Gallery section end */}
      </div>
      <ModalApp />
    </div>

  )
}

export default AboutPage